//------------ REACT IMPORT --------------//
import React, { useState } from "react";
//--------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Card, Image } from "react-bootstrap";
//------------ IMAGES IMPORT ---------------//
import { Delete, Eye, PdfImg } from "../../../../assets/images";
import AddReportModal from "../../Modals/AddReportModal";
import PaginationComponent from "../../CommanComponents/Pagination";
import NoDataComponent from "../../CommanComponents/NoDataComponent";
import Loader from "../../../Helper/loader";
import { dateFormat, renderImage, timeFormat } from "../../../Helper/General";


const Reports = (props) => {
    const [showReportModal, setShowReportModal] = useState(false);
    const {
        loader,
        patientReportsList,
        reportListTotalPages,
        handleDeleteReport,
        handleReportsBackClick,
        handleReportsNextClick,
        handlePage,
        page
    } = props


    const handleDeletClick = (id) => {
        if (props && props.handleDeleteReport) {
            props.handleDeleteReport(id);
        }
        else return;
    };


    const handleAddReport = (values) => {
        if (props && props.handleaddReport) {
            props.handleaddReport(values);
            setShowReportModal(false);
        }
        else return;
    };


    return (
        <>
            <div className="task_tab_screen">
                {
                    loader ?
                        <Loader
                            loader={loader}
                        />
                        :
                        patientReportsList && patientReportsList.length > 0 ?
                            patientReportsList.map((item, i) => (
                                <Card>
                                    <Card.Body key={i}>
                                        <Card>
                                            <Card.Body>
                                                <div className="card_details">
                                                    <div className="left_area">
                                                        <div className="img_one">
                                                            <Image
                                                                src={item.image && item.attachment ? renderImage(item.attachment) : PdfImg}
                                                                alt="..."
                                                            />
                                                        </div>
                                                        <div className="text_area">
                                                            <h5>{item.title ? item.title : ''}</h5>
                                                            <p>{item.description ? item.description : ''}</p>
                                                        </div>
                                                    </div>
                                                    <div className="right_area">
                                                        <div className="icons">
                                                            <Image
                                                                src={Eye}
                                                                alt="..."
                                                            />
                                                            {/* <Image
                                                                src={Delete}
                                                                alt="..."
                                                                onClick={() => handleDeletClick(item.id)}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="report_details">
                                                    <div className="report_updated_by">
                                                        {
                                                            item.created_by ?
                                                                <>
                                                                    <p>Updated by: {item.created_by}</p>
                                                                    <p>{dateFormat(item.created)}{' '}{timeFormat(item.created)}</p>
                                                                </>
                                                                :
                                                                null

                                                        }
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                        {
                                            (i + 1) === (patientReportsList.length) ?
                                                <Button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => setShowReportModal(true)}
                                                >
                                                    Add Reports
                                                </Button>
                                                :
                                                null

                                        }
                                    </Card.Body>
                                </Card>
                            ))
                            :
                            <div className="btn_area">
                                <Button
                                    className="submitBtn"
                                    type="button"
                                    onClick={() => setShowReportModal(true)}
                                >
                                    Add Reports
                                </Button>
                            </div>
                    // <NoDataComponent
                    //     message="No Reports Found!"
                    // />
                }
                {
                    showReportModal ? (
                        <AddReportModal
                            show={showReportModal}
                            close={() => setShowReportModal(false)}
                            handleAddReport={handleAddReport}
                        />
                        // <AddMedicineModal
                        //     show={showReportModal}
                        //     handleAdd={handleAddReport}
                        //     close={() => setShowReportModal(false)}
                        // />
                    ) : null
                }
            </div>
            {patientReportsList && patientReportsList.length > 0 ? (
                <PaginationComponent
                    page={page}
                    setPage={handlePage}
                    totalPages={reportListTotalPages}
                    handleBackClick={handleReportsBackClick}
                    handleNextClick={handleReportsNextClick}
                />
            ) : null}
        </>
    )
}

export default Reports;